module.exports = __webpack_public_path__ + "static/media/playground-monkey-bars.263f79ab.mov";